import { render, staticRenderFns } from "./DeliveryAreaFeeModifyFormIframe.vue?vue&type=template&id=764cb132&"
import script from "./DeliveryAreaFeeModifyFormIframe.vue?vue&type=script&lang=ts&"
export * from "./DeliveryAreaFeeModifyFormIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports